function createSmoothScroll(from = 0, to = 0, speed = 15) {
  let currentDelta = from > to ? from - to : to - from;
  const smoothscroll = () => {
    if (Math.abs(currentDelta) < speed)
      return;
    currentDelta = currentDelta - currentDelta / speed;
    window.requestAnimationFrame(smoothscroll);
    window.scrollTo(0, from > to ? to + currentDelta : to - currentDelta);
  };
  return smoothscroll();
}
var createSmoothScroll_default = createSmoothScroll;
export {
  createSmoothScroll,
  createSmoothScroll_default as default
};
